import { formatPrice } from '../../shared/utils/format-price.util';
import { DeliveryZoneCharge } from '../types/delivery-zone.type';
import { DeliveryZoneChargeRange } from '../types/delivery-zone-charge-range.type';
import { DeliveryZoneChargeInput } from '../types/dtos/create-delivery-zone.dto';

export const DELIVERY_VAT_RATE = 0.2;

export const DELIVERY_ZONE_CHARGES_COUNT = 3;

export const DEFAULT_CHARGE_THRESHOLDS = [0, 29, 39];

export const CHARGES_ERROR = 'Seuils croissants à partir de 0';

export const CHARGES_REQUIRED_ERROR = "Renseignez les trois paliers avant d'enregistrer";

export const computeCostsTTC = (costsHT: number): number => Math.round(costsHT * (1 + DELIVERY_VAT_RATE) * 100) / 100;

const hasTwoDecimalsAtMost = (value: number): boolean => Number.isFinite(value) && Number(value.toFixed(2)) === value;

export const areChargesValid = (charges: DeliveryZoneChargeInput[]): boolean =>
  charges.length === DELIVERY_ZONE_CHARGES_COUNT &&
  charges[0].threshold === 0 &&
  charges.every(
    (charge, index) =>
      hasTwoDecimalsAtMost(charge.threshold) &&
      hasTwoDecimalsAtMost(charge.costsHT) &&
      charge.costsHT >= 0 &&
      (index === 0 || charge.threshold > charges[index - 1].threshold)
  );

export const toChargeInputs = (charges: DeliveryZoneCharge[]): DeliveryZoneChargeInput[] =>
  charges.map(({ threshold, costsHT }) => ({ threshold, costsHT }));

export const NO_CHARGES_LABEL = 'Aucun palier';

const FREE_COST_LABEL = 'offert';

const ALL_AMOUNTS_RANGE_LABEL = 'Tout montant';

const formatThreshold = (threshold: number): string =>
  Number.isInteger(threshold) ? `${threshold}€` : formatPrice(threshold);

const formatChargeCost = (costsTTC: number): string => (costsTTC === 0 ? FREE_COST_LABEL : formatPrice(costsTTC));

const formatChargeRange = (charge: DeliveryZoneCharge, nextCharge: DeliveryZoneCharge | undefined): string => {
  if (nextCharge === undefined) {
    return charge.threshold === 0 ? ALL_AMOUNTS_RANGE_LABEL : `≥ ${formatThreshold(charge.threshold)}`;
  }

  return charge.threshold === 0
    ? `< ${formatThreshold(nextCharge.threshold)}`
    : `${formatThreshold(charge.threshold)} à ${formatThreshold(nextCharge.threshold)}`;
};

export const toChargeRanges = (charges: DeliveryZoneCharge[]): DeliveryZoneChargeRange[] => {
  const sortedCharges = [...charges].sort((left, right) => left.threshold - right.threshold);

  return sortedCharges.map((charge, index) => ({
    range: formatChargeRange(charge, sortedCharges[index + 1]),
    cost: formatChargeCost(charge.costsTTC),
  }));
};
